import styled from '@emotion/styled';
import {colors, fontFamily, fontSize, sizes} from 'patient-ping-remedy/packages/theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  & > *::after {
    content: '|';
    margin: 0 ${sizes.xSmall};
    color: ${colors.gray4};
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.span`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
`;

export const Link = styled.button`
  font-family: ${fontFamily.default};
  font-size: ${fontSize.standard};
  color: ${colors.blue4};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;
